import { ClientIDType } from '../../types';
import { I18n } from '../../wrappers';
export class ClientLocalizationBa {
    client;
    constructor(client) {
        this.client = client;
    }
    static idTypes() {
        return [
            { id: ClientIDType.tax_id_number, text: I18n.t('clients.id_types.tax_id_number'), prefix: null },
        ];
    }
    isLocalCountry() {
        return this.client.country === 'BIH';
    }
    isValid() {
        return !!this.client.id_number && !!this.client.id_type;
    }
}
const ClientLocalizationBaStatic = ClientLocalizationBa;
//# sourceMappingURL=ClientLocalizationBa.js.map